//# sourceMappingURL=segmented_button.mjs.map
/// <reference types="./segmented_button.d.mts" />
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { px } from "../../../sketch/sketch/css/length.mjs";
import * as $h_ from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $colors from "../../ds/colors.mjs";
import * as $icons from "../../ds/icons.mjs";
import * as $text from "../../ds/typography/text.mjs";
import { toList, CustomType as $CustomType, isEqual } from "../../gleam.mjs";

class Choice extends $CustomType {
  constructor(title, value) {
    super();
    this.title = title;
    this.value = value;
  }
}

export class Props extends $CustomType {
  constructor(on_selected, selected, disabled) {
    super();
    this.on_selected = on_selected;
    this.selected = selected;
    this.disabled = disabled;
  }
}
export const Props$Props = (on_selected, selected, disabled) =>
  new Props(on_selected, selected, disabled);
export const Props$isProps = (value) => value instanceof Props;
export const Props$Props$on_selected = (value) => value.on_selected;
export const Props$Props$0 = (value) => value.on_selected;
export const Props$Props$selected = (value) => value.selected;
export const Props$Props$1 = (value) => value.selected;
export const Props$Props$disabled = (value) => value.disabled;
export const Props$Props$2 = (value) => value.disabled;

export function on_selected(on) {
  return new Props(
    (value) => {
      on(value);
      return undefined;
    },
    new None(),
    false,
  );
}

export function selected(props, selected) {
  return new Props(props.on_selected, selected, props.disabled);
}

export function disabled(props, disabled) {
  return new Props(props.on_selected, props.selected, disabled);
}

export function choice(title, value) {
  return new Choice(title, value);
}

function option_item(label, is_selected, disabled, is_last, on_click) {
  let _pipe = $css.class$(
    toList([
      $css.compose($text.sm($text.medium)),
      $css.display("inline-flex"),
      $css.align_items("center"),
      $css.gap_("6px"),
      $css.padding_("6px 16px"),
      $css.cursor(
        (() => {
          if (disabled) {
            return "not-allowed";
          } else {
            return "pointer";
          }
        })(),
      ),
      $css.transition("background .2s, color .2s"),
      $css.background(
        (() => {
          if (disabled) {
            return $colors.light.grey_100;
          } else if (is_selected) {
            return $colors.light.blue_100;
          } else {
            return "transparent";
          }
        })(),
      ),
      $css.color(
        (() => {
          if (disabled) {
            return $colors.light.grey_400;
          } else if (is_selected) {
            return $colors.light.blue_800;
          } else {
            return $colors.light.grey_800;
          }
        })(),
      ),
      (() => {
        if (is_last) {
          return $css.none();
        } else {
          return $css.border_right("1px solid " + $colors.light.grey_200);
        }
      })(),
      $css.hover(
        (() => {
          if (disabled) {
            return toList([]);
          } else {
            return toList([
              $css.background(
                (() => {
                  if (is_selected) {
                    return $colors.light.blue_100;
                  } else {
                    return $colors.light.grey_100;
                  }
                })(),
              ),
            ]);
          }
        })(),
      ),
    ]),
  );
  return $h_.div(
    _pipe,
    toList([$e.on_click((_) => { return on_click(); })]),
    toList([
      (() => {
        if (is_selected) {
          return $icons.small($icons.checkmark());
        } else {
          return $h.none();
        }
      })(),
      $h.text(label),
    ]),
  );
}

function wrapper(children) {
  let _pipe = $css.class$(
    toList([
      $css.display("inline-flex"),
      $css.border("1px solid " + $colors.light.grey_200),
      $css.border_radius(px(8)),
      $css.overflow("hidden"),
      $css.background($colors.light.text_white),
    ]),
  );
  return $h_.div(_pipe, toList([]), children);
}

export function segmented_button(props, choices) {
  let count = $list.length(choices);
  return wrapper(
    $list.index_map(
      choices,
      (c, i) => {
        return option_item(
          c.title,
          isEqual(props.selected, new Some(c.value)),
          props.disabled,
          i === (count - 1),
          () => {
            let $ = props.disabled;
            if ($) {
              return undefined;
            } else {
              return props.on_selected(c.value);
            }
          },
        );
      },
    ),
  );
}
